/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");

export const TRIBE_BG = require("./res/images/Tribe_bg.png");
export const CAL_BG = require("./res/images/CAL_BG.png");
export const PURE_BG = require("./res/images/pure_bg.jpeg");
export const HARTS_BG = require("./res/images/harts_bg.jpeg");
export const THE_LOST_TRIBE_BG = require("./res/images/the_lost_tribe_bg.jpeg");
export const ROGUE_BG = require("./res/images/rogue_bg.jpeg");
export const SECRETS_BG = require("./res/images/Secrets_BG.png");

export const PAYMENT_SUCCESS = require("./res/images/payment_success.png");
export const PAYMENT_FAILED = require("./res/images/payment_failed.png");
export const PAYMENT_PENDING = require("./res/images/payment_pending.png");

export const IMAGES = [
  VLINDER_LOGO,
  TRIBE_BG,
  CAL_BG,
  PURE_BG,
  HARTS_BG,
  THE_LOST_TRIBE_BG,
  ROGUE_BG,
  PAYMENT_SUCCESS,
  PAYMENT_FAILED,
  PAYMENT_PENDING,
];
